import React, { FC } from "react";

import { SuggestedBadge } from "@/components/Badge";
import { Text } from "@/components/Text";
import { ILanguage } from "@/data/languages";
import { useCodelistTranslation } from "@/hooks/Codelist";

interface ISuggestedLanguageBadgeProps {
  language: ILanguage;
  onClick: () => void;
  onCheckedClick: () => void;
  isChecked?: boolean;
}

export const SuggestedLanguageBadge: FC<ISuggestedLanguageBadgeProps> = ({
  language,
  onClick,
  onCheckedClick,
  isChecked,
}) => {
  const tCodelist = useCodelistTranslation();

  return (
    <SuggestedBadge onClick={isChecked ? onCheckedClick : onClick} isChecked={isChecked} notCheckedIcon="add">
      <Text size="md">{tCodelist("languages", language)}</Text>
    </SuggestedBadge>
  );
};
